import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Button } from "@mui/material";
import MDBox from "components/MDBox";
import MDAlert from "../../components/MDAlert";
import MDTypography from "../../components/MDTypography";
import { AuthContext } from "../../context";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import GenericForm from "../genericForm";

function AddSuppliers() {
	const authContext = useContext(AuthContext);
	const navigate = useNavigate();
	const [data] = useState({});
	const [error] = useState("");

	const inputFields = [
		{ type: "text", name: "name", label: "Nome", required: true },
		{ type: "text", name: "vat_number", label: "Partita IVA", required: true },
		{ type: "text", name: "address", label: "Indirizzo", required: true },
		{ type: "text", name: "phone", label: "Telefono", required: true },
		{ type: "text", name: "email", label: "Email", required: true },
	];

	const requiredFields = [
		{ name: "name", nameDiplayed: "Nome" },
		{ name: "vat_number", nameDiplayed: "Partita IVA" },
		{ name: "address", nameDiplayed: "Indirizzo" },
		{ name: "email", nameDiplayed: "Email" },
	];

	return (
		<DashboardLayout>
			{authContext.hasAuth("ADD_SUPPLIERS") ? (
				<>
					<DashboardNavbar />
					<MDBox pt={6} pb={3}>
						<Button variant="contained" color="primary" onClick={() => navigate("/suppliers-managment")} sx={{ mt: 2, alignSelf: "center", minWidth: "100px", color: "#ffffff", marginBottom: "30px" }}>
							Torna alla tabella
						</Button>
						{error !== "" ? <Alert severity="error">{error}</Alert> : <GenericForm authModelName={"SUPPLIERS"} inputFields={inputFields} requiredFields={requiredFields} url="/suppliers-management/" old_data={data} useAPI={true} redirectOnSuccess="/suppliers-managment/edit" />}
					</MDBox>
				</>
			) : (
				<MDAlert color="error" dismissible>
					<MDTypography variant="body2">You don't have permission to access this page</MDTypography>
				</MDAlert>
			)}
		</DashboardLayout>
	);
}

export default AddSuppliers;
